import { store } from 'App';

export default (action) => {
    store.dispatch(action);
};
